/**
 * @generated SignedSource<<58f3ec277a31be031442f8863031636d>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type aiCustomAppsQuery$variables = {
  scope: string;
};
export type aiCustomAppsQuery$data = {
  readonly aiCustomApps: ReadonlyArray<{
    readonly aiCustomAppID: number;
    readonly description: string | null;
    readonly isActive: boolean;
    readonly mediaFactoryAppID: number;
    readonly name: string;
  }>;
};
export type aiCustomAppsQuery = {
  response: aiCustomAppsQuery$data;
  variables: aiCustomAppsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "scope"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "scope",
        "variableName": "scope"
      }
    ],
    "concreteType": "AICustomApp",
    "kind": "LinkedField",
    "name": "aiCustomApps",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "aiCustomAppID",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "description",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "mediaFactoryAppID",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isActive",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "aiCustomAppsQuery",
    "selections": (v1/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "aiCustomAppsQuery",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "1f874bd57e86574d6a17a929d2055493",
    "id": null,
    "metadata": {},
    "name": "aiCustomAppsQuery",
    "operationKind": "query",
    "text": "query aiCustomAppsQuery(\n  $scope: String!\n) {\n  aiCustomApps(scope: $scope) {\n    aiCustomAppID\n    name\n    description\n    mediaFactoryAppID\n    isActive\n  }\n}\n"
  }
};
})();

(node as any).hash = "9b2c209654e7e19aef40283c168ebdcb";

export default node;
